import { forwardRef } from "react";
import { Drawer as DrawerPrimitive } from "vaul";

import type {
  TDrawerTriggerElement,
  TDrawerTriggerProps,
} from "@/ui/components/overlay/Drawer/Drawer.config";

export const DrawerTrigger = forwardRef<TDrawerTriggerElement, TDrawerTriggerProps>(
  (props, ref) => (
    <DrawerPrimitive.Trigger
      data-component="DrawerTrigger"
      ref={ref}
      {...props}
    />
  ),
);

DrawerTrigger.displayName = "DrawerTrigger";
